import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormArray, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';

function getFormArray(size: number): FormArray {
  const arr = [];

  for (let i = 0; i < size; i++) {
    arr.push(new FormControl('', Validators.required));
  }

  return new FormArray(arr);
}

@Component({
    selector: 'app-otp-input',
    templateUrl: './otp-input.component.html',
    styleUrls: ['./otp-input.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: OtpInputComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: OtpInputComponent,
            multi: true,
        },],
    standalone: false
})

export class OtpInputComponent implements ControlValueAccessor {
  @ViewChildren('inputEl') inputEls!: QueryList<ElementRef<HTMLInputElement>>;
  // #scheduledFocus: number | null = null;

  @Output() otpFormSubmitEvent = new EventEmitter<string>();

  @Input() set size(size: number) {
    // this.inputsForm = getFormArray(size);
    this.#size = size;
  }

  #size = 6;
  // inputsForm = getFormArray(this.#size);
  inputsForm = new FormControl('', [Validators.required, Validators.minLength(this.#size), Validators.maxLength(this.#size)]);

  ngOnInit() {
    // TODO: TIM: Do we need to manually unsubscribe?
    this.inputsForm.valueChanges.subscribe(value => {
      // TODO: Tim: Add proper form validation check here
      if (this.inputsForm.valid) {
        this.submitOtpForm();
      }
    });
  }

  onChange?: (value: string) => void;
  onTouched?: () => void;

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    // Allow prefilling with OTP codes
    if (value?.length) {
      // If the value is longer than expected, try to extract OTP
      if (value.length > this.#size) {
        const extractedOtp = this.extractOtpFromMessage(value);
        if (extractedOtp) {
          this.inputsForm.setValue(extractedOtp);
          return;
        }
      } else if (value.length === this.#size && /^\d+$/.test(value)) {
        // If it's exactly the right length and all digits, use it
        this.inputsForm.setValue(value);
        return;
      }
    }
  
    // Reset input value
    this.inputsForm.setValue('');
  }

  /**
   * Extract OTP code from a message using various patterns
   */
  private extractOtpFromMessage(message: string): string | null {
    // Common OTP patterns
    const patterns = [
      // 6-digit codes at the start of the message
      /^(\d{6})\b/g,
      // 6-digit codes with various separators or no separators
      /\b(\d{6})\b/g,
      // 4-digit codes
      /\b(\d{4})\b/g,
      // Codes with dashes or spaces
      /\b(\d{3}[-\s]?\d{3})\b/g,
      // Codes preceded by common keywords
      /(?:code|otp|verification|pin|security)[\s:]*(\d{4,6})/gi,
      // Codes in parentheses or brackets
      /[\(\[](\d{4,6})[\)\]]/g,
      // Codes at the end of sentences
      /(\d{4,6})[.\s]*$/g
    ];

    for (const pattern of patterns) {
      const matches = message.match(pattern);
      if (matches && matches.length > 0) {
        // Clean the match (remove spaces, dashes, etc.)
        const cleanedCode = matches[0].replace(/\D/g, '');
        
        // Check if it's the right length
        if (cleanedCode.length === this.#size) {
          return cleanedCode;
        }
      }
    }

    return null;
  }

  /**
   * Public method to auto-fill OTP from a message
   */
  public autoFillFromMessage(message: string): boolean {
    const extractedOtp = this.extractOtpFromMessage(message);
    if (extractedOtp) {
      this.inputsForm.setValue(extractedOtp);
      this.onChange?.(extractedOtp);
      return true;
    }
    return false;
  }

  /**
   * Public method to directly set OTP value
   */
  public setOtpValue(otpCode: string): boolean {
    if (otpCode && otpCode.length === this.#size && /^\d+$/.test(otpCode)) {
      this.inputsForm.setValue(otpCode);
      this.onChange?.(otpCode);
      return true;
    }
    return false;
  }

  // setDisabledState(isDisabled: boolean): void {
  //   if (isDisabled) {
  //     this.inputsForm.disable();
  //   } else {
  //     this.inputsForm.enable();
  //   }
  // }

  // handleInput() {
  //   this.#updateWiredValue();
  
  //   if (this.#scheduledFocus != null) {
  //     this.#focusInput(this.#scheduledFocus);
  //     this.#scheduledFocus = null;
  //   }
  // }

  // handleKeyPress(e: KeyboardEvent, idx: number) {
  //   const isDigit = /\d/.test(e.key);
  
  //   // Safari fires Cmd + V through keyPress event as well
  //   // so we need to handle it here and let it through
  //   if (e.key === 'v' && e.metaKey) {
  //     return true;
  //   }
  
  //   if (isDigit && idx + 1 < this.#size) {
  //     this.#scheduledFocus = idx + 1;
  //   }
  
  //   if (isDigit && this.inputsForm.controls[idx].value) {
  //     this.inputsForm.controls[idx].setValue('');
  //   }
  
  //   return isDigit;
  // }

  // handleFocus(e: FocusEvent) {
  //   (e.target as HTMLInputElement).select();
  // }
  
  // #focusInput(idx: number) {
  //   setTimeout(() => this.inputEls.get(idx)?.nativeElement.focus());
  // }
  
  // #updateWiredValue() {
  //   setTimeout(() => this.onChange?.(this.inputsForm.value.join('')));
  // }

  // handleKeyDown(e: KeyboardEvent, idx: number) {
  //   if (e.key === 'Backspace' || e.key === 'Delete') {
  //     if (idx > 0) {
  //       this.#scheduledFocus = idx - 1;
  //     }
  //   }
  // }

  // handlePaste(e: ClipboardEvent, idx: number) {
  //   e.preventDefault();

  //   const pasteData = e.clipboardData?.getData('text');
  //   if (!pasteData) {
  //     return;
  //   }

  //   // Clean the pasted data to only include digits
  //   const digits = pasteData.replace(/\D/g, '');
    
  //   // If we have enough digits, fill the inputs
  //   if (digits.length >= this.#size) {
  //     for (let i = 0; i < this.#size; i++) {
  //       this.inputsForm.controls[i].setValue(digits[i]);
  //     }
  //     this.#focusInput(this.inputEls.length - 1);
  //     this.#updateWiredValue();
  //     this.onTouched?.();
  //   } else {
  //     // If we have fewer digits than inputs, fill what we can
  //     for (let i = 0; i < digits.length; i++) {
  //       if (idx + i < this.#size) {
  //         this.inputsForm.controls[idx + i].setValue(digits[i]);
  //       }
  //     }
  //     // Focus the next empty input
  //     const nextEmptyIndex = Math.min(idx + digits.length, this.#size - 1);
  //     this.#focusInput(nextEmptyIndex);
  //     this.#updateWiredValue();
  //     this.onTouched?.();
  //   }
  // }

  // // TODO: TIM: check how to implement validation
  // validate(control: AbstractControl<string, string>): ValidationErrors | null {
  //   if (!control.value || control.value.length < this.#size) {
  //     return {
  //       otpInput: 'Value is incorrect',
  //     };
  //   }
  
  //   return null;
  // }

  submitOtpForm() {
    // const otpCode = this.inputsForm.value.join('');
    const otpCode = this.inputsForm.value || '';
    this.otpFormSubmitEvent.emit(otpCode);
  }

  resetOtpForm(): void {
    this.inputsForm.reset();
  }
}
